// extracted by mini-css-extract-plugin
module.exports = {"link":"_1QoRU","ShinyButtonInverted":"_2VDWG","shinyButtonInverted":"_2VDWG","labelwrapper":"FOA92","label":"_1F6QJ"};